export default {
    blue: '#7C9AC0',
    green: '#9EBC97',
    red: '#F5333F',
    white: '#FFFEF9',
    black: '#222222',
    grey: '#C8C8C8',
    transparent: 'rgba(1,1,1,0)'
}
